// Invoices

export const INVOICE_STATUS = {
  DRAFT: 'draft',
  OPEN: 'open',
  PAID: 'paid',
  VOIDED: 'voided',
  PAST_DUE: 'past_due'
};
export const invoiceStatusToStatusTagUse = {
  [INVOICE_STATUS.OPEN]: 'warning',
  [INVOICE_STATUS.PAST_DUE]: 'error',
  [INVOICE_STATUS.PAID]: 'success',
  [INVOICE_STATUS.DRAFT]: 'default',
  [INVOICE_STATUS.VOIDED]: 'info'
};
export const invoiceStatusToStatusTagMessage = {
  [INVOICE_STATUS.OPEN]: 'invoices.status.open',
  [INVOICE_STATUS.PAST_DUE]: 'invoices.status.pastDue',
  [INVOICE_STATUS.PAID]: 'invoices.status.paid',
  [INVOICE_STATUS.DRAFT]: 'invoices.status.draft',
  [INVOICE_STATUS.VOIDED]: 'invoices.status.voided'
};
export const invoiceStatusToStatusDotUse = {
  [INVOICE_STATUS.OPEN]: 'warning',
  [INVOICE_STATUS.PAST_DUE]: 'danger',
  [INVOICE_STATUS.PAID]: 'success',
  [INVOICE_STATUS.DRAFT]: 'default',
  [INVOICE_STATUS.VOIDED]: 'info'
};
export const invoiceStatusToStatusDotMessage = {
  [INVOICE_STATUS.OPEN]: 'invoices.status.open',
  [INVOICE_STATUS.PAST_DUE]: 'invoices.status.pastDue',
  [INVOICE_STATUS.PAID]: 'invoices.status.paid',
  [INVOICE_STATUS.DRAFT]: 'invoices.status.draft',
  [INVOICE_STATUS.VOIDED]: 'invoices.status.voided'
};

// Subscriptions

export const SUBSCRIPTION_DISPLAY_STATUS = {
  ACTIVE: 'ACTIVE',
  FAILED_PAYMENT: 'FAILED_PAYMENT',
  UNPAID: 'UNPAID',
  SCHEDULED: 'SCHEDULED',
  CANCELED: 'CANCELED',
  EXPIRED: 'EXPIRED'
};
export const displayStatusToStatusDotUse = {
  [SUBSCRIPTION_DISPLAY_STATUS.ACTIVE]: 'success',
  [SUBSCRIPTION_DISPLAY_STATUS.FAILED_PAYMENT]: 'danger',
  [SUBSCRIPTION_DISPLAY_STATUS.UNPAID]: 'danger',
  [SUBSCRIPTION_DISPLAY_STATUS.SCHEDULED]: 'info',
  [SUBSCRIPTION_DISPLAY_STATUS.CANCELED]: 'default',
  [SUBSCRIPTION_DISPLAY_STATUS.EXPIRED]: 'default'
};
export const displayStatusToStatusBadgeMessage = {
  [SUBSCRIPTION_DISPLAY_STATUS.ACTIVE]: 'subscriptions.status.active',
  [SUBSCRIPTION_DISPLAY_STATUS.FAILED_PAYMENT]: 'subscriptions.status.failedPayment',
  [SUBSCRIPTION_DISPLAY_STATUS.UNPAID]: 'subscriptions.status.unpaid',
  [SUBSCRIPTION_DISPLAY_STATUS.SCHEDULED]: 'subscriptions.status.scheduled',
  [SUBSCRIPTION_DISPLAY_STATUS.CANCELED]: 'subscriptions.status.canceled',
  [SUBSCRIPTION_DISPLAY_STATUS.EXPIRED]: 'subscriptions.status.expired'
};

// Commerce Payments

export const COMMERCE_PAYMENT_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  PROCESSING: 'PROCESSING',
  FAILED: 'FAILED'
};
export const commercePaymentStatusToStatusDotUse = {
  [COMMERCE_PAYMENT_STATUS.SUCCEEDED]: 'success',
  [COMMERCE_PAYMENT_STATUS.PROCESSING]: 'warning',
  [COMMERCE_PAYMENT_STATUS.FAILED]: 'danger'
};
export const commercePaymentStatusToMessage = {
  [COMMERCE_PAYMENT_STATUS.SUCCEEDED]: 'paymentHistory.status.succeeded',
  [COMMERCE_PAYMENT_STATUS.PROCESSING]: 'paymentHistory.status.processing',
  [COMMERCE_PAYMENT_STATUS.FAILED]: 'paymentHistory.status.failed'
};

// Payment Methods

export const PAYMENT_METHOD_TYPE = {
  CARD: 'CARD',
  ACH: 'ACH',
  BACS: 'BACS',
  PADS: 'PADS',
  SEPA: 'SEPA'
};